import Swiper, { Navigation } from 'swiper'
Swiper.use([Navigation])

export const initTextVisualsTabs = () => {
  const sliders = [...document.querySelectorAll('.js-tab-slider')]
  const tabs = [...document.querySelectorAll('.js-tab')]
  const content = [...document.querySelectorAll('.js-content')]
  if (tabs.length <= 0 || content.length <= 0) { return false }

  new Tabs(tabs, content)

  sliders.forEach(slider => {
    new Swiper(slider, {
      direction: 'horizontal',
      loop: false,
      watchOverflow: true,
      freeMode: true,
      slidesPerView: 'auto'
    })
  })
}

class Tabs {
  constructor (tabs, content) {
    this.tabs = tabs
    this.content = content
    this.init()
  }

  init = () => {
    this.bind()
    const urlParams = new URLSearchParams(window.location.search)
    const activeTab = urlParams.get('tab')
    if (activeTab) {
      const activeIndex = this.tabs.findIndex((tab) => tab.dataset.name === activeTab)
      if (activeIndex >= 0) {
        this.show(activeIndex)
      }
    }
  }

  bind () {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.show(index)
      })
    })
  }

  show (index) {
    this.tabs.forEach(tab => { tab.classList.remove('active') })
    this.content.forEach(content => { content.classList.remove('active') })

    this.tabs[index].classList.add('active')
    this.content[index].classList.add('active')
  }
}
